import axios from "axios";
import type { InferGetServerSidePropsType } from "next";

import { BreadCrumb } from "@/components/BreadCrumb";
import type { CreateNewsDto } from "@/entities/types/entities";
import { PageLayout } from "@/layouts/PageLayout";
import { Routes } from "@/shared/constants";
import { API_BASE } from "@/shared/constants/private";
import { Articles } from "@/view/Articles";

import img from "@/shared/assests/backgrounds/novosti.webp";

export default function News({ articles }: InferGetServerSidePropsType<typeof getServerSideProps>) {
    const items = [{ label: "Новости" }];

    return (
        <PageLayout
            title="Новости Lift Media Group – события рекламного агентства"
            description="Новости от Lift Media Group. Следите за обновлениями, специальными предложениями и кейсами из мира рекламы."
        >
            <BreadCrumb model={items} />
            <Articles
                url={Routes.NEWS}
                title={"Новости"}
                listArticles={articles.length ? articles : []}
                imgSrc={img}
            />
        </PageLayout>
    );
}
export const getServerSideProps = async () => {
    const resNews= await axios<CreateNewsDto[]>(`${API_BASE}/news`, {params: {onlyPublished: true}});

    return {
        props: {
            articles: resNews.data,
        },
    };
};
